<template>
    <component :is="isMobileSize ? 'mobile' : 'pc'" />
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { normal } from '../../defaultSpacing';
import commonMixin from '../index';
export default {
    mixins: [commonMixin],
    data: function() {
        let config = {
            fullColumn: false,
            ...normal
        };
        return {
            ...config,
            keys: Object.freeze(Object.keys(config))
        };
    },
    components: {
        pc: defineAsyncComponent(() => import(/* webpackChunkName: "modules/md-sold-estimate/fashion/pc"*/ './pc.vue')),
        mobile: defineAsyncComponent(() => import(/* webpackChunkName: "modules/md-sold-estimate/fashion/mobile"*/ './mobile.vue'))
    },

    computed: {
        isMobileSize() {
            return this.platform.isMobile;
        },
        config() {
            let keys = this.keys;
            let config = {};
            for (let i = 0; i < keys.length; i++) {
                config[keys[i]] = this[keys[i]];
            }
            return config;
        }
    }
};
</script>
